import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {finalize, switchMap, tap} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import {SummaryModalComponent} from "../../routing-review/summary-modal/summary-modal.component";
import {ActivatedRoute} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {NgIf} from '@angular/common';
import {ResultsListComponent} from '@shared/results-list/results-list.component';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';
import {BaseService} from '@shared/services/base.service';
import {GenericModalComponent} from '@shared/modals/generic-modal/generic-modal.component';
import {PaymentsService} from '@shared/services/payments.service';
import {ToastService} from '@shared/services/toast.service';

@Component({
    selector: 'app-application-list',
    templateUrl: './application-list.component.html',
    styleUrls: ['./application-list.component.css'],
    imports: [
        ResultsListComponent,
        HelpDocsLinksComponent,
        FormsModule,
        NgIf
    ]
})
export class ApplicationListComponent implements OnInit {
  type: string;
  @ViewChild(ResultsListComponent) resultList: ResultsListComponent;
  searchObj = {search: '', submitted: true, accepted: false};
  open = {};
  nonfilterableFields = ['status', 'generator_count', 'fee', 'fee_balance'];
  service: BaseService;
  loading = false;
  //todo: make dynamic by using service.meta?
  displayFields = ['site_name', 'permit_number', 'status', 'status_date', 'type', 'fee', 'fee_balance',
    'generator_count'];
  items;
  contentType: ReplaySubject<number> = new ReplaySubject<number>();

  rowButtons = [
    {
      title: 'Add Payment',
      hideExpression: 'item.fee_balance > 0',
      func: (item) => {
        this.paymentsService.open_modal(null, item, this.service.meta.content_type, this.service).subscribe();
      }
    },
    {
      title: 'Review Application',
      hideExpression: 'item.status !== "accepted" && item.status !== "rejected"',
      func: item => {
        const summaryModal = this.modalService.open(SummaryModalComponent, {size: 'xl'});
        item.content_type = this.service.meta.content_type;
        summaryModal.componentInstance.item = item;
        summaryModal.componentInstance.reviewType = 'acceptance';
        summaryModal.componentInstance.accept = (item, modalInstance) => this.accept(item, modalInstance);

      }
    },
    {
      title: '<i class="fa fa-close"></i>',
      hideExpression: 'item.status !== "accepted"',
      tooltip: 'Click to delete',
      func: (item) => {
        const confirmDialog = this.modalService.open(GenericModalComponent, {size: 'sm'});
        confirmDialog.componentInstance.title = 'Please confirm';
        confirmDialog.componentInstance.text = 'Are you sure you want to remove <b>' + item.site_name + '\'s</b> application?';
        confirmDialog.result.then(() => {
          this.service.delete(item.globalid).pipe(tap(() => {
            this.resultList._search();
          })).subscribe();
        });
      }
    },
    {
      title: '<i class="fa fa-envelope"></i>',
      hideExpression: 'true',
      tooltip: 'Click to resend application',
      func: item => {
        const confirmDialog = this.modalService.open(GenericModalComponent);
        confirmDialog.componentInstance.title = 'Please confirm';
        confirmDialog.componentInstance.message = 'Are you sure you want to resend the application for <b>' + item.site_name + '</b>?';
        confirmDialog.result.then(() => {
          // todo: bring back this end points for anything standby gen and reporting
          this.service.get<Response>(`${item.globalid}/email_application`).subscribe(
            response => this.toastr.success(response),
            r => this.toastr.error(r.details)
          );
        });
      }
    }
  ];

  constructor(private http: HttpClient, public paymentsService: PaymentsService, public modalService: NgbModal,
              public toastr: ToastService,
              public route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.type = data.type
      this.service = new BaseService(`${environment.baseUrl}/${this.type}`, this.http);
    })

    this.route.queryParams.subscribe(params => {
      this.searchObj = {...this.searchObj, ...params};
    })
  }

  openCalendar(e, date) {
    this.open[date] = true;
  }

  public runSearch() {
    this.resultList._search();
  }

  private accept(item, modalInstance) {
    const confirmDialog = this.modalService.open(GenericModalComponent, {backdrop: 'static'});
    confirmDialog.componentInstance.title = 'Please Confirm';
    confirmDialog.componentInstance.text = 'Are you sure you want to accept this?';
    return confirmDialog.result.then(() => {
      this.service.put(`${item.globalid}/accept`, item).pipe(
        tap(() => {
          modalInstance.close();
          this.resultList._search();
        })
      ).subscribe();

    }).catch(e => console.error(e));
  }
}
